import {StepName, STEPS} from "@src/Steps/Steps";
import { MouseEvent } from "react";

type FooterLegalTutelaireProps = {
  stepName?: StepName;
};

export function ProtectionDonneesTutelaire({ stepName }: FooterLegalTutelaireProps) {
  const openMailTo = (e: MouseEvent) => {
    window.open("mailto:donneespersonnelles@tutelaire.fr", "mail");
    e.preventDefault();
  };

  return (
    <p id="footer-legal__footnote">
      {(stepName === 'CONTACT_INFOS' || stepName === 'ABOUT_YOU') &&
        <small>
          (1) Si vous ne souhaitez pas faire l’objet de prospection commerciale par voie téléphonique, vous pouvez vous inscrire gratuitement sur la liste d’opposition au démarchage téléphonique BLOCTEL sur le site internet <a href="https://www.bloctel.gouv.fr" target="_blank" rel="noreferrer">www.bloctel.gouv.fr</a>.
          <br />
          Les consommateur(rices) inscrit(es) sur cette liste ne peuvent être démarché(es) sauf lorsqu’il s’agit de sollicitations du professionnel intervenant dans le cadre de l’exécution d’un contrat en cours et ayant un rapport avec l’objet de ce contrat.
        </small>
      }
      <small>
        Les informations recueillies dans le présent formulaire, ont pour
        finalité de pouvoir vous rappeler et répondre à vos questions. Vous
        disposez des droits d&apos;accès, de rectification, d&apos;opposition,
        de portabilité, d&apos;effacement et de limitation du traitement vous
        concernant.
        <br />
        Pour l&apos;exercice de vos droits, adressez un courrier simple au
        responsable de traitement : Tutélaire, 157 avenue de France - 75013
        Paris ou un courriel à :{" "}
        <a
          href="mailto:donneespersonnelles@tutelaire.fr"
          target="_blank"
          rel="noreferrer"
          onClick={openMailTo}
        >
          donneespersonnelles@tutelaire.fr
        </a>
        .
        <br />
        Pour plus d&apos;informations relatives à la gestion de vos données,
        vous pouvez à tout moment consulter notre{" "}
        <a
          href="https://www.tutelaire.fr/protection-des-donnees"
          target="_blank"
          rel="noreferrer"
        >
          politique de confidentialité
        </a>{" "}
        sur le site internet{" "}
        <a href="https://www.tutelaire.fr" target="_blank" rel="noreferrer">
          www.tutelaire.fr
        </a>{" "}
        ou la demander par courrier simple au responsable de traitement de
        Tutélaire.
      </small>
    </p>
  );
}

export function FooterLegalTutelaire({ stepName }: FooterLegalTutelaireProps) {
  return (
    <>
      <div className="footer-legal__part">
        <ProtectionDonneesTutelaire stepName={stepName} />
      </div>

      <div className="footer-legal__part">
        <small>
          Mutuelle soumise aux dispositions du livre II du Code de la mutualité.
        </small>
        <small>
          SIREN 775 682 164.
          <br />
          Siège social : 157 avenue de France
          <br />
          75013 Paris
        </small>

        <div className="footer-legal__logos">
          <img
            className="footer-legal__logo-tutelaire"
            alt="logo tutelaire"
            src="/logo-tutelaire.png"
          />
          <img
            className="footer-legal__logo-mutualite"
            alt="logo mutualité francaise"
            src="/logo-mutualite-francaise.png"
          />
        </div>
        <div className="stepper__mentions-legales">
          <a
            href="https://www.tutelaire.fr/mentions-legales-cookies"
            target="_blank"
            rel="noreferrer"
          >
            Mentions légales
          </a>
        </div>
      </div>
    </>
  );
}
